module.exports = __webpack_public_path__ + "static/media/32.ed4a60d7.png";